import { ABTestingGroup, ABTestingGroupType } from './types/ABTesting';

export const getABTestingGroupForUser = (userId: number): ABTestingGroupType => {
  const hash = userId % 2;

  return hash === 0 ? ABTestingGroup.GROUP_A : ABTestingGroup.GROUP_B;
};

export const getABTestingGroupForCompany = (companyId: number): ABTestingGroupType => {
  const hash = companyId % 2;

  return hash === 0 ? ABTestingGroup.GROUP_A : ABTestingGroup.GROUP_B;
};
